export const NEXT_BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;
export const NEXT_FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL;
export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY_GEOCODING;
export const GOOGLE_MAPS_API_KEY_2 = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
export const NEXT_IMAGE_CDN =
    process.env.NEXT_IMAGE_CDN || "https://images.hod.care";
export const NEXT_PUBLIC_DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL;
export const NEXT_PUBLIC_LOGO = process.env.NEXT_PUBLIC_WEBSITE_LOGO;
export const NEXT_RAZORPAY_KEY_ID = process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID;
export const NEXT_PUBLIC_NONCE_PUBLIC_KEY =
    process.env.NEXT_PUBLIC_NONCE_PUBLIC_KEY;
export const NEXT_ONLINE_REPORTS_URL =
    process.env.NEXT_PUBLIC_ONLINE_REPORT_URL;
export const NEXT_PUBLIC_INVOICE = process.env.NEXT_PUBLIC_INVOICE_URL;
export const DEFAULT_CENTER = {
    lat: 28.7041,
    lng: 77.1025,
};
export const NEXT_PUBLIC_RAZORPAY_KEY = process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID;
export const NEXT_IS_LOCAL = 1;
export const sitemapPrefix = {
    sitemapDomain:
        process.env.NEXT_PUBLIC_SITEMAP_URL_DOMAIN || "https://www.hod.care",
    imageDomain:
        process.env.NEXT_PUBLIC_SITEMAP_IMAGE_DOMAIN ||
        "https://images.hod.care",
};
export const CUSTOMER_CARE_TEL = `18005715715`;
export const CUSTOMER_CARE_DISPLAY = "1800 5 715 715";
export const FOR_MOBILE_VIEW = `+918045614100`;

export const IS_PATIENT_REACHED_MORE_THAN_SEVEN = 7;

export const httpStatus = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SUCCESS: 200,
    UNAUTHENTICATED: 244,
};
export const seoDefaults = {
    name: "House of Diagnostics",
    description: `House of Diagnostics is a leading diagnostic center in Delhi, India. We offer a wide range of diagnostic tests like blood tests, urine tests, X-ray, MRI, CT scan, etc. at affordable prices.`,
    mobileWith91: CUSTOMER_CARE_TEL,
    address: "15 Hargovind Enclave, Delhi, India",
    addressCity: "Delhi",
    addressPincode: "110092",
    email: "info@hod.care",
    brand: "House Of Diagnostics",
    context: "https://schema.org",
    baseUrl: "https://www.hod.care",
    logo: `${NEXT_IMAGE_CDN}/icon/hod_logo.svg`,
    contactPoint: {
        "@type": "ContactPoint",
        telephone: CUSTOMER_CARE_TEL,
        contactType: "customer service",
        areaServed: "IN",
    },
    publisher: {
        "@type": "Organization",
        name: "House Of Diagnostics",
        logo: {
            "@type": "ImageObject",
            url: NEXT_PUBLIC_LOGO,
        },
    },
    brand: {
        "@type": "Brand",
        name: "House Of Diagnostics",
    },
    webUrls: [
        "https://www.facebook.com/houseofdiagnostics/",
        "https://x.com/hodcare",
        "https://www.instagram.com/houseofdiagnosticsofficial",
        "https://www.youtube.com/c/Houseofdiagnostics",
        "https://www.linkedin.com/company/house-of-diagnostics",
        "https://in.pinterest.com/houseofdiagnostics/",
    ],
};

export const NEXT_PAYU_SCRIPT = process.env.NEXT_PUBLIC_PAY_U_SCRIPT;

export const VISITTYPE = {
    HOME: "h",
    CENTRE: "c",
};

export const UPDATECART = {
    NEW: "new",
    OLD: "old",
};

export const TIMEFRAME = [
    {
        value: "6",
        label: "6 Months",
    },
    {
        value: "12",
        label: "1 Years",
    },
    {
        value: "24",
        label: "2 Years",
    },
];

export const HOMECOLLECTIONCHARGE = {
    amountBelow: 999,
    amountCharge: 149,
};

export const RESTRICTED_PATHS = [
    "/my-account",
    "/checkout",
    "/cart",
    "/purchase",
];

export const FIREBASE_CONFIG = {
    apiKey:
        process.env.NEXT_PUBLIC_FIREBASE_API_KEY ||
        "AIzaSyDwEotLcwG-QLjkG2ybRljYetc12-CE00c",
    authDomain:
        process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ||
        "hod-customer-app.firebaseapp.com",
    projectId:
        process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "hod-customer-app",
    storageBucket:
        process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ||
        "hod-customer-app.firebasestorage.app",
    messagingSenderId:
        process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "594752354168",
    appId:
        process.env.NEXT_PUBLIC_FIREBASE_APP_ID ||
        "1:594752354168:web:12b2d6900f860d5885fa8d",
    measurementId:
        process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || "G-60T5T70GVN",
};

export const FIREBASE_WEB_PUSH_CERT =
    process.env.NEXT_PUBLIC_FIREBASE_WEB_PUSH_CERT;

export const PAYMENT_METHODS = {
    COD: 1,
    RAZORPAY: 6,
    PAYU: 8,
    JUSPAY:9
};

export const HISTORY_OPTIONS = [
    { label: "Diabetic", value: "isDiabitic" },
    {
        label: "Kidney Patient",
        value: "isKidney",
    },
    {
        label: "Wheelchair",
        value: "isWheelchair",
    },
    {
        label: "Oxygen Support",
        value: "isOxygenSupport",
    },
];

export const HISTORY_DETAILS = {
    isDiabitic:
        "Overnight fasting is required for the scan. For FDG Scans - please no not take insulin or anti-diabetic medication on the morning of the day of the scan. Sugar levels are requried to be below 150 mg/dL for the scan. Please remind the receptionist upon your arrival, about your diabetic status",
    isDiabeticNonFDG: "4-6 hour fasting is required for the scan",
    isKidney:
        "For eGFR values below 60 ml/min/1.73 m2, scans will be performed without contrast. Please carry your creatinine reports and inform the receptionist on the day of the scan.",
    isWheelchair:
        "Please inform the receptionist for special care for your scan. Please avoid clothing with metal zips, hooks or buttons.",
    isOxygenSupport:
        "We advise your attendant to kindly visit the facility and discuss with the clinical team before making your booking, for special arrangements for your scan.",
};
